import { render, staticRenderFns } from "./ARTStandings.vue?vue&type=template&id=d5985d6c&scoped=true&"
import script from "./ARTStandings.vue?vue&type=script&lang=js&"
export * from "./ARTStandings.vue?vue&type=script&lang=js&"
import style0 from "./ARTStandings.vue?vue&type=style&index=0&id=d5985d6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5985d6c",
  null
  
)

export default component.exports